module.exports = __webpack_public_path__ + "img/info3.4d6beaa9.png";